exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.columnDescription[data-v-de078732] {\n    font-weight: bold;\n}\n.fieldChanges[data-v-de078732] {\n    padding-left: 25px;\n}\n.changesNotFound[data-v-de078732] {\n    font-weight: bold;\n    font-style: italic;\n    color: green;\n}\n", ""]);

// exports
